import { NgModule, ModuleWithProviders } from '@angular/core';

import { ProcessingServiceConfig, PROCESSING_CONFIG } from './processing.config';
import { ProcessingService } from './processing.service';

@NgModule({
  providers: [
    ProcessingService,
  ],
})
export class ProcessingModule {

  static forRoot(config: ProcessingServiceConfig): ModuleWithProviders<ProcessingModule> {
    return {
      ngModule: ProcessingModule,
      providers: [
        ProcessingService,
        {
          provide: PROCESSING_CONFIG,
          useValue: config,
        },
      ],
    };
  }

  static forChild(config: ProcessingServiceConfig): ModuleWithProviders<ProcessingModule> {
    return ProcessingModule.forRoot(config);
  }

}
